/* This file holds static colors to be used with map layers */

// Soil SSURGO zone colors to be given to each zone after they are sorted
export const SOIL_SSURGO_ZONE_COLORS = [
  '#800000',
  '#008000',
  '#000080',
  '#808000',
  '#800080',
  '#008080',
  '#9999FF',
  '#993366',
  '#FFFFCC',
  '#CCFFFF',
  '#660066',
  '#FF8080',
  '#0066CC',
  '#CCCCFF',
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#FF00FF',
  '#00FFFF',
];

export const ACTIVITY_COLORS = {
  blue: '#307af7',
  green: '#38d753',
  purple: '#b037e4',
  red: '#ef3e3e',
  yellow: '#f7ec41',
  orange: '#ff8439',
};

export const IMPORTED_SHAPEFILE_PROPERTY_COLOR = '#ffffff';
